<template>
    <div class="my-4">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Januar</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Februar</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">März</a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                <table class="table table-borderless table-tab">
                    <thead>
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                        <th scope="col">08</th>
                        <th scope="col">09</th>
                        <th scope="col">10</th>
                        <th scope="col">11</th>
                        <th scope="col">12</th>
                        <th scope="col">13</th>
                        <th scope="col">14</th>
                        <th scope="col">15</th>
                        <th scope="col">16</th>
                        <th scope="col">17</th>
                        <th scope="col">18</th>
                        <th scope="col">19</th>
                        <th scope="col">20</th>
                        <th scope="col">21</th>
                        <th scope="col">22</th>
                        <th scope="col">23</th>
                        <th scope="col">24</th>
                        <th scope="col">25</th>
                        <th scope="col">26</th>
                        <th scope="col">27</th>
                        <th scope="col">28</th>
                        <th scope="col">29</th>
                        <th scope="col">30</th>
                        <th scope="col">31</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    </tbody>
                </table>

            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                <table class="table table-borderless table-tab">
                    <thead>
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                        <th scope="col">08</th>
                        <th scope="col">09</th>
                        <th scope="col">10</th>
                        <th scope="col">11</th>
                        <th scope="col">12</th>
                        <th scope="col">13</th>
                        <th scope="col">14</th>
                        <th scope="col">15</th>
                        <th scope="col">16</th>
                        <th scope="col">17</th>
                        <th scope="col">18</th>
                        <th scope="col">19</th>
                        <th scope="col">20</th>
                        <th scope="col">21</th>
                        <th scope="col">22</th>
                        <th scope="col">23</th>
                        <th scope="col">24</th>
                        <th scope="col">25</th>
                        <th scope="col">26</th>
                        <th scope="col">27</th>
                        <th scope="col">28</th>
                        <th scope="col">29</th>
                        <th scope="col">30</th>
                        <th scope="col">31</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    </tbody>
                </table>

            </div>
            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

                <table class="table table-borderless table-tab">
                    <thead>
                    <tr>
                        <th scope="col">Mo</th>
                        <th scope="col">Di</th>
                        <th scope="col">Mi</th>
                        <th scope="col">Do</th>
                        <th scope="col">Fr</th>
                        <th scope="col">Sa</th>
                        <th scope="col">So</th>
                    </tr>
                    <tr>
                        <th scope="col">01</th>
                        <th scope="col">02</th>
                        <th scope="col">03</th>
                        <th scope="col">04</th>
                        <th scope="col">05</th>
                        <th scope="col">06</th>
                        <th scope="col">07</th>
                        <th scope="col">08</th>
                        <th scope="col">09</th>
                        <th scope="col">10</th>
                        <th scope="col">11</th>
                        <th scope="col">12</th>
                        <th scope="col">13</th>
                        <th scope="col">14</th>
                        <th scope="col">15</th>
                        <th scope="col">16</th>
                        <th scope="col">17</th>
                        <th scope="col">18</th>
                        <th scope="col">19</th>
                        <th scope="col">20</th>
                        <th scope="col">21</th>
                        <th scope="col">22</th>
                        <th scope="col">23</th>
                        <th scope="col">24</th>
                        <th scope="col">25</th>
                        <th scope="col">26</th>
                        <th scope="col">27</th>
                        <th scope="col">28</th>
                        <th scope="col">29</th>
                        <th scope="col">30</th>
                        <th scope="col">31</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                        <td><div class="checkbox"></div></td>
                    </tr>

                    </tbody>
                </table>

            </div>
        </div>


        <!-- Legende Start -->
        <div class="legend">
            <div class="row">

                <div class="col-12 col-lg-3">
                    <div class="legend__item">
                        <span class="checkbox checkbox--circle-gray"></span>
                        <span class="legend__text">Wochenende</span>
                    </div>
                </div>

                <div class="col-12 col-lg-3">
                    <div class="legend__item">
                        <span class="checkbox checkbox--pink-border"></span>
                        <span class="legend__text">Feiertag</span>
                    </div>
                </div>

                <div class="col-12 col-lg-3">
                    <div class="legend__item">
                        <span class="checkbox checkbox--blue"></span>
                        <span class="legend__text">Absenz</span>
                    </div>
                </div>

                <div class="col-12 col-lg-3">
                    <div class="legend__item">
                        <span class="checkbox checkbox--doubleBox">
                        </span>
                        <span class="legend__text">Überlappende Absenz</span>
                    </div>
                </div>

            </div>
        </div>
        <!-- Legende Ends -->
    </div>
</template>

<script>
    export default {
        name: "TableTabs"
    }
</script>

<style lang="scss">
    @import '../assets/scss/variables';

    .tab-pane {
        overflow-x: scroll;
    }

    .checkbox--circle-gray {
        border: 0;
        background: $alert-dark-gray;
        border-radius: 100%;
    }

    .checkbox--doubleBox {
        position: relative;
        border: 0;

        &:before {
            content: "";
            display: block;
            height: 100%;
            width: 100%;
            background-color: $alert-blue;
            position: absolute;
            z-index: 10;
            left: -10px;
            top: 0;
            border-radius: 3px;
        }

        &:after {
            content: "";
            position: relative;
            height: 100%;
            width: 100%;
            background-color: $alert-gray;
            right: 0;
            top: -.7rem;
            z-index: 9;
            display: block;
            border-radius: 3px;
        }
    }


    .nav-tabs {
        border-bottom: 0;
        .nav-link {
            color: $alert-dark-gray;
            border: 0;
            padding-left: 0;

            &.active {
                color: $alert-blue;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/TableTabs.vue